export default __webpack_public_path__ + "static/media/servicetop.c2cfd192.jpg";